
import { Vue, Options } from "vue-class-component";
import StorageService from "../../services/StorageService";
import ChangePasswordModal from "../ChangePasswordModal.vue";
import HelpModal from "../HelpModal.vue";
import { useStore } from "vuex";
import { closePage, createAction } from "@/utils/patientLoggerPage";

@Options({
  components: {
    ChangePasswordModal,
    HelpModal
  },
  emits: ['openModalEmit', 'openModalEmit', 'closeModal']

})
export default class HeaderMenu extends Vue {
  private storageService = new StorageService();
  globalStore = useStore();
  user: any = null;
  username: any = null;
  showModal = false;
  showHelpModal = false;
  $keycloak: any; //globally defined in main.ts
  portalMessages: any = null;

  async created() {
    this.user = this.storageService.getUser();
    this.username = this.getUserName();
    this.portalMessages = this.getUserPortalMessages();
  }

  getUserPortalMessages() {
    return this.user.portalMessages;
  }

  async openMessagesPage() {
    console.warn("open messages");
    await this.$router.push("messages");
  }

  async logout() {
    const patientLoggerPageId = this.storageService.get("patientLoggerPageId");

    await createAction(
      "logout",
      patientLoggerPageId,
      undefined,
      undefined,
      this.user.patientsId
    );
    await closePage(patientLoggerPageId, this.user.patientsId);

    // Before logging out it will remove the user from the localstorage
    // and set the i18n locale to match the browser
    this.storageService.delete("user");
    this.storageService.delete("token");
    this.$i18n.locale = navigator.language;
    await this.$keycloak.logout();
  }

  getUserName() {
    return this.user.username;
  }

  openModal() {
    this.showModal = true;
  }

  openHelpModal() {
    this.showHelpModal = true;
  }

  onChildClick() {
    this.showModal = false;
    this.showHelpModal = false;
    this.$emit('closeModal')
  }

  a() {
    this.globalStore.commit("open", {
      type: "warning",
      title: this.$t("ALERTS.NAVIGATION.FAILED.TITLE"),
      text: this.$t("ALERTS.NAVIGATION.FAILED.TEXT")
    });
  }
}
